import { useCallback } from 'react';
import styled from '@emotion/styled';
import { IconButton } from '@mui/material';
import { Edit2 } from 'react-feather';
import { useGroupTagsDispatch } from './hooks';

export default function Add() {
  const dispatch = useGroupTagsDispatch();

  const handleClick = useCallback(() => {
    dispatch(state => ({ ...state, editing: true }));
  }, [dispatch]);

  return (
    <IconButton
      size='small'
      onClick={handleClick}>
      <EditIcon />
    </IconButton>
  );
}

const EditIcon = styled(Edit2)(({ theme }) => ({
  color: theme.palette.primary.main,
}));

export { Add };